(function () {


  function setupVariantButtons() {


    document.querySelectorAll('.custom-quick-add').forEach(function (quickAdd) {


      let json = quickAdd.querySelector('.product-variants-json');
      let addButton = quickAdd.querySelector('.quick-add__submit');
      let variantInput = quickAdd.querySelector('.product-variant-id');
      let buttons = quickAdd.querySelectorAll('.variant-size-btn');


      if (!json || !addButton || !variantInput) {
  return;
}


      let variants;


      try {

        variants = JSON.parse(json.textContent);

      } catch (error) {

        console.error('Variant JSON error:', error);
        return;

      }


      // store selected options
      quickAdd.selectedOptions = {};


      buttons.forEach(function (button) {


        let optionIndex = button.dataset.optionIndex;
        let value = String(button.dataset.optionValue).trim();



        let available = variants.some(function (variant) {


          return (
            variant.available === true &&
            String(variant.options[optionIndex]).trim() === value
          );


        });



        if (!available) {


          button.disabled = true;

          button.classList.add('sold-out');


        } else {


          button.disabled = false;

          button.classList.remove('sold-out');


        }


      });



      if(buttons.length === 0){

    let defaultVariant = variants.find(function(variant){
        return variant.available === true;
    });


   if(defaultVariant){

    variantInput.value = defaultVariant.id;


    variantInput.dispatchEvent(
      new Event('change',{
        bubbles:true
      })
    );


    addButton.disabled = false;

}
    else{

        addButton.disabled = true;

    }

}else{

    addButton.disabled = true;

    variantInput.value = '';

}



    });


  }





  function selectVariant(button) {


    let quickAdd = button.closest('.custom-quick-add');


    if (!quickAdd || button.disabled) {
      return;
    }



    let json = quickAdd.querySelector('.product-variants-json');
    let variantInput = quickAdd.querySelector('.product-variant-id');
    let addButton = quickAdd.querySelector('.quick-add__submit');



    if (!json || !variantInput || !addButton) {
      return;
    }



    let variants = JSON.parse(json.textContent);



    if (!quickAdd.selectedOptions) {

      quickAdd.selectedOptions = {};

    }



    let optionIndex = button.dataset.optionIndex;

    let selectedValue = String(
      button.dataset.optionValue
    ).trim();



    // save selected option

    quickAdd.selectedOptions[optionIndex] = selectedValue;



    // active class only same option group

    quickAdd.querySelectorAll(
      '.variant-size-btn[data-option-index="' + optionIndex + '"]'
    )
    .forEach(function(btn){

      btn.classList.remove('active');

    });



    button.classList.add('active');





    // find exact variant

    let selectedVariant = variants.find(function(variant){


      return Object.keys(
        quickAdd.selectedOptions
      )
      .every(function(index){


        return (
          String(variant.options[index]).trim() ===
          String(quickAdd.selectedOptions[index]).trim()
        );


      });


    });




    if (!selectedVariant) {


      variantInput.value = '';

      addButton.disabled = true;

      return;

    }




    // set variant id

    variantInput.value = selectedVariant.id;



    variantInput.dispatchEvent(
      new Event('change',{
        bubbles:true
      })
    );



    // check all options selected

    let optionCount = Number(
      quickAdd.dataset.optionCount
    );



    if(
      Object.keys(
        quickAdd.selectedOptions
      ).length === optionCount
    ){


      addButton.disabled = false;


    }else{


      addButton.disabled = true;


    }



  }





  document.addEventListener(
    'click',
    function(event){


      let button = event.target.closest('.variant-size-btn');


      if(button){


        event.preventDefault();

        event.stopPropagation();


        selectVariant(button);


      }


    },
    true
  );





  if(document.readyState === 'loading'){


    document.addEventListener(
      'DOMContentLoaded',
      function(){

        setupVariantButtons();

      }
    );


  }else{


    setupVariantButtons();


  }





  document.addEventListener(
    'shopify:section:load',
    function(){

      setupVariantButtons();

    }
  );

})();